import { List } from 'immutable';
import { getShapesLayer } from '../../Helpers/helpers';

const removeAll = canvasState => canvasState.set(getShapesLayer(canvasState), List());

export default removeAll;
